"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  DocumentPreview: true
};
exports.DocumentPreview = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _react = _interopRequireDefault(require("react"));
var _ImageDocumentPreview = require("./image/ImageDocumentPreview");
Object.keys(_ImageDocumentPreview).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _ImageDocumentPreview[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ImageDocumentPreview[key];
    }
  });
});
var _PdfDocumentPreview = require("./pdf/PdfDocumentPreview");
Object.keys(_PdfDocumentPreview).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _PdfDocumentPreview[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _PdfDocumentPreview[key];
    }
  });
});
var _excluded = ["type"];
var DocumentPreview = function DocumentPreview(_ref) {
  var type = _ref.type,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return type === 'pdf' ? /*#__PURE__*/_react.default.createElement(_PdfDocumentPreview.PdfDocumentPreview, rest) : /*#__PURE__*/_react.default.createElement(_ImageDocumentPreview.ImageDocumentPreview, rest);
};
exports.DocumentPreview = DocumentPreview;